import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-developer-experience',
    templateUrl: './developer-experience.component.html',
    styleUrls: ['./developer-experience.component.scss']
})
export class DeveloperExperienceComponent implements OnInit {

    tabData: any;
    activeTabIndex: any;
    showDoc = false;
    paramsTobeSent: any;

    constructor(public route: ActivatedRoute) {
    }

    ngOnInit() {
        this.tabData = [];
        //this.tabData.push({method: '', apiUrl: '', params: {}});
        //this.activeTabIndex = 0;
        this.route.queryParams.subscribe(params => {
            if (params) {
                if (params.showDoc) {
                    this.paramsTobeSent = params;
                    this.showDoc = true;
                } else {
                    this.addTab(params);
                    this.showDoc = false;
                }
            }
        });
    }

    addTab(params = {}) {
        this.tabData.push({method: '', apiUrl: '', params: params});
        this.activeTabIndex = this.tabData.length - 1;
    }

    closeTab(index) {
        this.tabData.splice(index, 1);
        this.activeTabIndex = this.tabData.length - 1;
    }

    tabNameChanged(tabName, index) {
        this.tabData[index].method = tabName.method;
        this.tabData[index].apiUrl = tabName.apiUrl;
    }

    createPaddingRight() {
        document.getElementById('view:developer_experience').style.paddingRight = '400px';
    }

    removePaddingRight() {
        document.getElementById('view:developer_experience').style.paddingRight = '0px';
    }

}
